import React from 'react'
import { connect } from 'react-redux'
import { Box, Flex } from 'reflexbox'
import { Button, Card } from '@blueprintjs/core'
import { getTeamById, importTeam } from 'src/store/modules/cmdb/teams'

class TeamCard extends React.Component {
    handleCheckClick = (team) => () => {
        // this.props.toggleContactForImport(team.id)
    }

    handleImportClick = () => {
        this.props.importTeam(this.props.team.id)
    }

    shouldComponentUpdate(nextProps) {
        return true
        // const selectedChanged = this.props.selected !== nextProps.selected
        // return selectedChanged
    }

    render() {
        const { team, exists } = this.props
        return (
            <Card className="contact-card" interactive elevation={2}>
                <Flex w={1}>
                    <Box>
                        <h3 className="contact-card-heading">{team.name}</h3>
                    </Box>
                    {/* <Box ml="auto">
                    <Checkbox onChange={this.handleCheckClick(team)} checked={selected || false}/>
                </Box> */}
                </Flex>
                <p>
                    {team.members} member{`${team.members === 1 ? '' : 's'}`}
                </p>
                <p>{team.email || ' '}</p>
                <p>
                    <Button
                        text={exists ? 'Sync' : 'Import'}
                        onClick={this.handleImportClick}
                    />
                </p>
            </Card>
        )
    }
}

export default connect(
    (state, ownProps) => {
        const team = getTeamById(state, ownProps.team)
        return {
            team,
            exists: team.exists,
            selected: team.selected,
        }
    },
    { importTeam }
)(TeamCard)
